import { Entity } from "@/shared/Entity"

class Classification extends Entity {
    static NAME_ID = "Nombre"
    static EMAIL_ID = "Correo electrónico"
    static RFC_ID = "RFC"
    static CURP_ID = "CURP"
    static GENDER_ID = "Género"
    static BIRTHDATE_ID = "Fecha de nacimiento"
    static PLACE_OF_BIRTH_ID = "Lugar de nacimiento"
    static MARITAL_STATUS_ID = "Estado civil"
    static WEBSITE_ID = "Página web";
    static ADDRESS_ID = "Domicilio";
    static POSTAL_CODE_ID = "Código postal";
    static INTERNAL_NUMBER_ID = "Número interior";
    static EXTERNAL_NUMBER_ID = "Número exterior";
    static STREET_ID = "Calle";
    static FEDERATIVE_ENTITY_ID = "Entidad federativa";
    static DELETEGATION_ID = "Delegación / Municipio"
    static COLONY_ID = "Colonia"
    static CAPA_ID = "CAPA ID"
    static CELL_ID = "Celular"

}

export { Classification };